export default __webpack_public_path__ + "static/media/wholesale55-pormayor55-logo.a0cefe63.png";